import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import InputBox from '../../components/Modal/InputBox';
import ModalButtons from '../../components/Modal/ModalButtons';
import DeleteModalSkeleton from '../../components/Skeletons/DeleteModalSkeleton';

const DeleteFileModal = ({ loading, data }) => {
	const { t } = useTranslation();
	const { deleteFileModal, setDeleteFileModal, deleteFileInput, setDeleteFileInput, handleDeleteFile } = data;

	return (
		<Modal show={deleteFileModal.status}>
			<ModalHeading heading={t('screens.fileExchange.deleteFileTitle', { name: deleteFileModal.file.name })} />
			{loading ? (
				<DeleteModalSkeleton />
			) : (
				<ModalForm style={{ marginBottom: '2.5rem' }} onSubmit={handleDeleteFile}>
					<InputsSection style={{ width: '34rem' }}>
						<InputBox
							label={t('screens.fileExchange.enterToDeleteFile', { name: deleteFileModal.file.name })}
							placeholder={deleteFileModal.file.name}
							value={deleteFileInput.value}
							onChange={(event) => {
								setDeleteFileInput({ value: event.target.value, error: '' });
							}}
							errorMessage={deleteFileInput.error}
							style={{ width: '30rem' }}
						/>
						<p className='dangerText'>{t('screens.fileExchange.deleteFileWarn')}</p>
					</InputsSection>

					<ModalButtons
						submitButtonLabel={t('screens.fileExchange.deleteFileBtn')}
						onSubmit={handleDeleteFile}
						cancelButtonLabel={t('screens.fileExchange.cancel')}
						onCancel={() => {
							setDeleteFileModal({ file: {}, status: false });
							setDeleteFileInput({ value: '', error: '' });
						}}
					/>
				</ModalForm>
			)}
		</Modal>
	);
};

export default DeleteFileModal;
